import { useSelector } from "react-redux";
import { RaytebRequests } from "../../../_services";
import useFetch from "../../../_services/fetch";
import { ItemType } from "../../../models/ViewModels/RecordCatalogViewModel";
import {
  DrugHistoryItem,
  DrugHistoryType,
} from "../../../models/ViewModels/RecordViewModel";
import { LoadingFit } from "../../../share/Components";
import Card from "../../../share/Components/Card/Card";
import { ProvideTypeahead, Typeahead } from "../../../share/Elements";
import Icon from "../../../share/Elements/Icons/Icons";
import { ReducerType } from "../../../storeManager/ReducerType";
import { LoginInterface } from "../../../Interfaces/LoginInterface";
import { useState } from "react";

type TypeaheadData = {
  show: boolean;
  data?: any;
};

const RecordDrugHistory = ({
  item,
  onItemChange,
}: {
  item?: DrugHistoryType;
  onItemChange?: (updatedItem: DrugHistoryType) => void; // A function to handle item changes
}) => {
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  );
  const [drug, setDrug] = useState<DrugHistoryItem>();
  const getDrugs = useFetch<
    Array<ItemType<number>>,
    unknown,
    {
      filter: string;
    }
  >({
    request: RaytebRequests.Profile_Drugs_GET({ token: user.token }),
    onSuccess(data) {},
  });
  const [showList, setshowList] = useState<TypeaheadData>({
    show: false,
  });

  const selectedItem = (item: ItemType<number>) => {
    const updatedItem: DrugHistoryItem = {
      ...drug,
      drugId: item.id,
      drug: item.title,
    };
    setDrug(updatedItem);
    setshowList({ ...showList, show: false });
  };

  const handleAbstractClick = (index: number) => {
    // Handle abstract click logic

    const updatedItems = [...(item?.items || [])];
    updatedItems[index] = {
      ...updatedItems[index],
      showAbstract: !updatedItems[index].showAbstract,
    };

    const drugData: DrugHistoryType = {
      ...item,
      items: updatedItems,
    };
    onItemChange && onItemChange(drugData);
  };

  const handleDeleteClick = (index: number) => {
    const updatedItems = [...(item?.items || [])];
    updatedItems.splice(index, 1);

    const updatedObject = { ...item, items: updatedItems };

    onItemChange && onItemChange(updatedObject);
  };
  const handleAddItem = () => {
    const updatedItems = item?.items ? [...item.items] : [];
    updatedItems.push(drug!);

    const updatedDrugItem: DrugHistoryType = {
      ...item,
      items: updatedItems,
    };
    onItemChange && onItemChange(updatedDrugItem);
    setDrug({});
  };
  return (
    <>
      <div className="p-6 ">
        <ProvideTypeahead
          className={` ${true ? "before:absolute before:z-50 " : ""}`}
          showList={showList.show}
          listChildren={
            <ListChildren
              onClick={(item) => {
                selectedItem(item);
              }}
              listData={getDrugs.result}
              isLoading={getDrugs.isLoading}
              onHide={() => {
                setshowList({ show: false });
              }}
            />
          }
        >
          <div className="px-1 flex justify-start  items-end md:!w-1/2 md:mx-auto ">
            <Typeahead
              innerText="علائم  بیماری ..."
              className="before:absolute before:bg-white/30 before:w-full before:h-full"
              onClick={(e) => {
                e.stopPropagation();
                e.target.select();
              }}
              // onBlur={() => setshowList({ ...showList, show: false })}
              onFocus={() => setshowList({ ...showList, show: true })}
              onChange={(e) =>
                getDrugs.reFetch(null, {
                  filter: e.target.value,
                })
              }
              value={drug?.drug}
            ></Typeahead>
          </div>
        </ProvideTypeahead>
        <div className="mt-4 flex justify-end items-center gap-7">
          <div className="flex justify-end gap-4 items-center w-full">
            <Icon
              icon="rayteb-add-circular"
              className="text-xl text-primaryLight"
              onClick={handleAddItem}
            />
          </div>
        </div>
        <div className="mt-5 grid grid-cols-1 gap-1 ">
          {item?.items?.length! > 0
            ? item?.items?.map((n, i) => (
                <Card
                  key={i}
                  text={n.drug}
                  footer={
                    <CardFooter
                      item={n}
                      onAbstractClick={() => handleAbstractClick(i)}
                      onDeleteClick={() => handleDeleteClick(i)}
                    />
                  }
                >
                  <span className="text-[9px] text-primaryLight ml-1  font-bold"></span>
                  <br />
                  <span className="text-xs text-primaryLight ml-1 font-bold"></span>
                </Card>
              ))
            : null}
        </div>
      </div>
    </>
  );
};
const CardFooter = ({
  item,
  onAbstractClick,
  onDeleteClick,
}: {
  item?: DrugHistoryItem;
  onAbstractClick: () => void;
  onDeleteClick: () => void;
}) => (
  <>
    <div className="w-full flex  justify-between items-center pt-3">
      <div className="flex justify-center itmes-center gap-2">
        <Icon
          icon="rayteb-medical-ophthalmology"
          className={`text-xl  ${
            item?.showAbstract ? "text-primary" : "text-disable"
          }`}
          onClick={onAbstractClick}
        />
        <Icon
          icon="rayteb-delete"
          className="text-xl text-primary"
          onClick={onDeleteClick}
        />
      </div>
    </div>
  </>
);
type ListChildrenType = {
  listData?: Array<ItemType<number>>;
  className?: string | undefined;
  isLoading: boolean;
  onHide?: () => void;
  onClick?: (param: ItemType<number>) => void;
};
const ListChildren: React.FC<ListChildrenType> = ({
  className,
  listData,
  isLoading,
  onClick,
  onHide,
}) => {
  return (
    <>
      <div>
        <LoadingFit isLoading={isLoading} />
        <div className="border-b border-disable bg-white py-2 px-1 flex items-center">
          <Icon
            icon="rayteb-android-close"
            className="text-xl"
            onClick={() => onHide?.()}
          />

          <p className="text-xs mr-2 font-bold text-warn ">علائم بیماری ...</p>
        </div>

        <div className="h-64 overflow-y-auto">
          <ul
            className={`flex justify-center flex-col  
           items-center p-2 shadow-sm ${className ?? ""}`}
          >
            {listData?.map((n, i) => (
              <li
                key={i}
                className="flex justify-start items-center h-8  py-1 w-full hover:bg-primaryDefault hover:cursor-pointer "
                onClick={(e) => {
                  e.stopPropagation(); // Prevent the event from reaching the parent div and closing the list

                  onClick?.(n);
                }}
              >
                <p className="text-xs font-bold text-end text-primaryLight">
                  {n.title}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};
export default RecordDrugHistory;
